import { render, staticRenderFns } from "./inviteDialog.vue?vue&type=template&id=728f872a&scoped=true"
import script from "./inviteDialog.vue?vue&type=script&lang=js"
export * from "./inviteDialog.vue?vue&type=script&lang=js"
import style0 from "./inviteDialog.vue?vue&type=style&index=0&id=728f872a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728f872a",
  null
  
)

export default component.exports